import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { isInBetaEnvironment } from '../config/features';

function Header({ onToggleMenu, pageTitle }) {
  return (
    <header className="bg-conform-red shadow-md shadow-black/20">
      <div className="flex items-center justify-between px-3 h-[44px] md:px-4 md:h-[48px]">
        {/* Left: Brand + page title on mobile */}
        <div className="flex items-center min-w-0">
          <Link to="/" className="flex items-center gap-2 no-underline shrink-0">
            <img
              src="/images/CT-Icon-White-sm.png"
              alt=""
              width={64}
              height={56}
              className="h-5 md:h-7 w-auto"
              style={{ filter: 'brightness(0)' }}
            />
            <img
              src="/images/CT-Wordmark-Black1-sm.png"
              alt="CONFORM.TOOLS"
              width={237}
              height={40}
              className="h-3.5 md:h-4 w-auto"
            />
            <span className="hidden md:inline font-headline font-bold text-conform-black tracking-tight text-2xl">
              DataCalc
            </span>
            {isInBetaEnvironment() && (
              <span className="font-bold rounded bg-conform-black/10 text-conform-black uppercase text-[8px] px-1 py-0.5 md:text-[10px] md:px-1.5 tracking-wider">
                Beta
              </span>
            )}
          </Link>
          {pageTitle && (
            <div className="flex md:hidden items-center gap-1.5 min-w-0 ml-2">
              <span className="text-conform-black shrink-0">/</span>
              <span className="text-xs font-medium text-conform-black truncate">{pageTitle}</span>
            </div>
          )}
        </div>

        {/* Right: Hamburger (mobile only) */}
        <button
          onClick={onToggleMenu}
          className="flex md:hidden items-center justify-center w-9 h-9 rounded-lg text-conform-black hover:text-conform-yellow transition-colors shrink-0 ml-2"
          aria-label="Open menu"
        >
          <Menu className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
}

export default Header;
